<script>
  if (window.self === window.top) {
  } else {
    let divWhite = document.createElement("div");
    divWhite.innerHTML = "";
    document.body.appendChild(divWhite);
  }
</script>
<app-sub-menu [subMenus]="subMenus"></app-sub-menu>
<div class="container-fluid bg-box configuracion">
  <h3>{{ title }}</h3>
  <hr />

  <div class="row mt-4 pasos">
    <div class="col-12 d-flex justify-content-sm-center">
      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>1</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">
            Nombre y ponderación
          </p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>2</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">Bloques y rubros</p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>3</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">Preguntas</p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--active d-flex justify-content-sm-center align-items-center"
        >
          <span>4</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--active text-center mt-2">
            Tipos de respuesta
          </p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>5</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">
            Configuración de respuestas
          </p>
        </div>
      </div>

      <div
        class="pasos__item d-flex flex-column justify-content-sm-center align-items-center"
      >
        <div
          class="pasos__item--enable d-flex justify-content-sm-center align-items-center"
        >
          <span>6</span>
        </div>
        <div class="pasos__titulo">
          <p class="pasos__titulo--enable text-center mt-2">
            Reglas de negocio
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-5 mb-3">
    <div class="col">
      <h3>Listado de rubros</h3>
      <p>Agregar las preguntas que llevaran los rubros</p>
    </div>
    <div class="col text-right">
      <button
        *ngIf="bloques"
        [disabled]="!existsTiposRespuestas()"
        class="btn btn-sm btn-primary"
        (click)="redirectPaso5()"
      >
        <i class="fa fa-arrow-right"></i> Continuar
      </button>
    </div>
  </div>

  <div class="card mt-2" *ngFor="let bloque of bloques">
    <div class="card-body">
      <h3 class="card-title">{{ bloque.Nombre }}</h3>

      <div id="accordion{{ bloque.IdBloque }}">
        <div class="card mb-1" *ngFor="let rubro of bloque.Rubros">
          <div
            class="card-header"
            id="heading{{ rubro.IdRubro }}"
            aria-expanded="true"
            style="cursor: pointer"
            data-bs-toggle="collapse"
            [attr.data-bs-target]="'#collapse' + rubro.IdRubro"
            [attr.aria-controls]="'collapse' + rubro.IdRubro"
          >
            <div class="row">
              <div class="col-md-9">
                <h6 class="mb-0">{{ rubro.Nombre }}</h6>
              </div>
            </div>
          </div>
          <div
            id="collapse{{ rubro.IdRubro }}"
            class="collapse"
            [attr.aria-labelledby]="'heading' + rubro.IdRubro"
            [attr.data-parent]="'#accordion' + bloque.IdBloque"
          >
            <div class="card-body">
              <form
                *ngIf="rubro.Preguntas.length > 0"
                [attr.data-idBloque]="bloque.IdBloque"
                [attr.data-idRubro]="rubro.IdRubro"
                (submit)="frmPostTipoRespuestas($event)"
                ngNativeValidate
              >
                <div class="row">
                  <div class="col-12">
                    <div class="table-responsive">
                      <table class="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th scope="col">Orden</th>
                            <th scope="col">Descripción</th>
                            <th scope="col">Ponderación por pregunta</th>
                            <th scope="col">Tipo de respuesta</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let pregunta of rubro.Preguntas">
                            <td>{{ pregunta.Orden }}</td>
                            <td>{{ pregunta.Descripcion }}</td>
                            <td>{{ pregunta.Ponderacion }}</td>
                            <td>
                              <select
                                required
                                name="select-{{ pregunta.IdPregunta }}"
                                id="select-{{ pregunta.IdPregunta }}"
                                (change)="validarPonderacion($event, pregunta.IdPregunta, pregunta.Ponderacion, rubro.Preguntas)"
                                [(ngModel)]="pregunta.TipoRespuesta.IdTipoRespuesta"
                              >
                                <option value="0" disabled selected>
                                  Seleccione...
                                </option>
                                <option
                                  [value]="tipoRespuesta.IdTipoRespuesta"
                                  *ngFor="let tipoRespuesta of tipoRespuestas"
                                >
                                  {{ tipoRespuesta.Descripcion }}
                                </option>
                              </select>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col text-right">
                    <button type="submit" class="btn btn-sm btn-primary" [disabled]="disableSave">
                      <i class="fa fa-save"></i> Guardar tipos de respuesta del
                      rubro
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
